export default __webpack_public_path__ + "static/media/t_ok.17c034c5.svg";